import React from 'react'
import Header from '../inc/Header'
import ScrollToTop from "react-scroll-to-top";
import {Link} from "react-router-dom";
import misaa2026 from "../images/misaa charity 2026 new.jpeg";
import misaa2026photo from "../images/Arijit Gupta Sir.jpeg";
import shibajisir from "../images/Shibaji Sir.jpeg";
import jacketsweredistributed from "../images/jackets were distributed photo.jpeg";
import jacketsweredistributedphhoto from "../images/jackets were distributed.jpeg";
import mam from "../images/mam.jpeg";
import jackerdistributor from "../images/jackets were distributed.jpeg";

function Charity2026() {
  return (
    <div>
        <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
         
                    <ScrollToTop smooth top="100" color="grey"/>
        
                    <div className='bestberhamporeschoolmis'>
                    <div className="album py-1">
                        <div className="container mt-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/Gallery" style={{ color: "darkblue" }} >Back</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">The programme was held at Bharat Shebashram, Chuanpur, in Berhampore, Murshidabad
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                     </div>



                     <div className="album py-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-3">
                            <div className="card">
                                <img src={misaa2026} className="card-img-top" alt="misaa2026" />

                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card">
                                <img src={misaa2026photo} className="card-img-top" alt="misaa2026" />

                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card">
                                <img src={shibajisir} className="card-img-top" alt="jackets were distributed" />

                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card">
                                <img src={jacketsweredistributed} className="card-img-top" alt="jackets were distributed 2026" />

                            </div>
                        </div>

                        <div className="col-md-4 mt-3">
                            <div className="card">
                                <img src={jacketsweredistributedphhoto} className="card-img-top" alt="jackets were distributed 2026" />

                            </div>
                        </div>
                         <div className="col-md-4 mt-3">
                            <div className="card">
                                <img src={mam} className="card-img-top" alt="jackets were distributed 2026" />

                            </div>
                        </div>
                         <div className="col-md-4 mt-3">
                            <div className="card">
                                <img src={jackerdistributor} className="card-img-top" alt="jackets were distributed 2026" />

                            </div>
                        </div>
                      </div>
                      </div>
                      </div>
                   

<br/>
    </div>
  )
}

export default Charity2026